export default __webpack_public_path__ + "img/pkback-1f1fee60.png";